import React, { useEffect, useState } from "react";
//outsource
import { Space, Select, Button, Tooltip, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { detailBranchSelector, detailSelector } from "../../../../store/branch/branch.selector";
import { getStaffsByIds } from "../../../../store/staff/staff.action";
import { setStaff } from "../../../../store/var/var.action";
import { PlusOutlined } from "@ant-design/icons";
//components

const SelectStaff = ({ block, data, handleAddRow, edit }) => {
  // -------------------------- VAR --------------------------
  let users = data?.map((d) => d?.userId);
  // -------------------------- STATE --------------------------
  const [options, setOptions] = useState(null);
  const [staff, setStaff] = useState(null);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailBranchSelector);
  const coop = branch?.coop || null;
  // console.log({branch})
  // -------------------------- FUNCTION --------------------------
  const onSelect = (value) => {
    let target = options?.find((o) => o?.id === value);
    // setStaff(target);
    handleAddRow(target);
  };

  // const addRow = () => {
  //   if (staff) {
  //     handleAddRow(staff);
  //   }
  // };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (coop) {
      dispatch(
        getStaffsByIds({ ids: coop }, (res) => {
          if (res.status === 200) {
            console.log(res.data);
            setOptions(res.data);
          }
        })
      );
    }
  }, [coop]);
  // -------------------------- RENDER --------------------------
  // const renderButton = () => {
  //   let enabled = block === null ? true : false;
  //   return (
  //     <Tooltip title="Add Row">
  //       <Col flex="auto">
  //         <Button
  //           // disabled={!enabled}
  //           disabled={!edit}
  //           onClick={addRow}
  //           type="primary"
  //           icon={<PlusOutlined />}
  //         />
  //       </Col>
  //     </Tooltip>
  //   );
  // };
  // -------------------------- MAIN --------------------------
  const converted = renderOptions(options, users) || [];

  return (
    <Row justify="space-between" gutter={[10, 10]}>
      <Col flex="auto">
        <Select
          style={{ width: "100%" }}
          placeholder="Select Staff.."
          options={converted}
          onSelect={onSelect}
          showSearch
          value={null}
          optionFilterProp="label"
          // filterOption={(input, option) =>
          //   option.label.toLowerCase().includes(input.toLowerCase())
          // }
        />
      </Col>
      {/* {renderButton()} */}
    </Row>
  );
};

export default SelectStaff;

const renderOptions = (data, users) => {
  let final = [];
  data?.forEach((item) => {
    const value = item?.id;
    const fullName = `${item?.firstName} ${item?.lastName}`;
    const username = (item?.username && `(${item?.username})`) || "";
    const label = `${fullName} ${username}`;

    const result = {
      value,
      label,
    };

    if (!users?.includes(value)) {
      final = [...final, result];
    }
  });

  return final;
};
